// src/jira/project/types.ts
var JiraProjectAriResourceOwner = "jira", JiraProjectAriResourceType = "project";

export {
  JiraProjectAriResourceOwner,
  JiraProjectAriResourceType
};
